"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PointConstraint_dragOrigin, _PointConstraint_point, _PointConstraint_radius, _PointConstraint_rotation;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointConstraint = void 0;
const gl_matrix_1 = require("gl-matrix");
const InteractionData_1 = require("../InteractionData");
const DragConstraintsHelper_1 = require("./DragConstraintsHelper");
class PointConstraint {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor(_point, _radius = 0, _rotation) {
        // #region Properties (4)
        _PointConstraint_dragOrigin.set(this, void 0);
        _PointConstraint_point.set(this, void 0);
        _PointConstraint_radius.set(this, 0);
        _PointConstraint_rotation.set(this, void 0);
        __classPrivateFieldSet(this, _PointConstraint_point, _point, "f");
        __classPrivateFieldSet(this, _PointConstraint_radius, _radius, "f");
        __classPrivateFieldSet(this, _PointConstraint_rotation, _rotation || { axis: gl_matrix_1.vec3.fromValues(0, 0, 1), angle: 0 }, "f");
    }
    // #endregion Constructors (1)
    // #region Public Methods (2)
    intersect(viewer, node, ray) {
        const closestPoint = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _PointConstraint_point, "f"), ray.origin);
        const directionDistance = gl_matrix_1.vec3.dot(closestPoint, ray.direction);
        if (directionDistance < 0) {
            gl_matrix_1.vec3.copy(closestPoint, ray.origin);
        }
        else {
            gl_matrix_1.vec3.multiply(closestPoint, gl_matrix_1.vec3.copy(closestPoint, ray.direction), gl_matrix_1.vec3.fromValues(directionDistance, directionDistance, directionDistance));
            gl_matrix_1.vec3.add(closestPoint, closestPoint, ray.origin);
        }
        const distance = gl_matrix_1.vec3.distance(closestPoint, __classPrivateFieldGet(this, _PointConstraint_point, "f"));
        if (distance < __classPrivateFieldGet(this, _PointConstraint_radius, "f"))
            return { distance, transformation: DragConstraintsHelper_1.calculateDragMatrix(node, __classPrivateFieldGet(this, _PointConstraint_point, "f"), __classPrivateFieldGet(this, _PointConstraint_rotation, "f"), __classPrivateFieldGet(this, _PointConstraint_dragOrigin, "f"), closestPoint) };
        return;
    }
    setup(viewer, node, ray, intersection) {
        const data = node.data.find(d => d instanceof InteractionData_1.InteractionData);
        __classPrivateFieldSet(this, _PointConstraint_dragOrigin, data && data.dragOrigin ? data.dragOrigin : intersection.point, "f");
        return this.intersect(viewer, node, ray);
    }
}
exports.PointConstraint = PointConstraint;
_PointConstraint_dragOrigin = new WeakMap(), _PointConstraint_point = new WeakMap(), _PointConstraint_radius = new WeakMap(), _PointConstraint_rotation = new WeakMap();
//# sourceMappingURL=PointConstraint.js.map